define('uikit/channel',['require','exports','module','marionette','backbone','backbone.radio'],function(require, exports, module){
  var Mn = require('marionette');
  var Backbone = require('backbone');
  var Radio = require('backbone.radio');

  module.exports = Radio.channel('uikit');
});
